import PropTypes from "prop-types";
import React from "react";
import { Row, Col, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import FeatureFlagStore from "../stores/FeatureFlagStore";

export default class Setting extends React.Component
{
	constructor(props)
	{
		super(props);
	}

	render()
	{
		const label = this.props.label;
		const labelSize = this.props.labelSize;
		const isPremiumFeature = this.props.isPremiumFeature;
		const isPremiumUser = this.props.isPremiumUser;
		const premiumAccountEnabled = FeatureFlagStore.premiumAccountEnabled();
		let enabled = this.props.enabled;

		if (!enabled && !isPremiumFeature)
		{
			return null;
		}
		if (isPremiumFeature && !isPremiumUser)
		{
			enabled = false;
		}

		let premiumComponent = premiumAccountEnabled ?
			<LinkContainer to="/upgrade">
				<NavItem>Become a premium user to use this feature.</NavItem>
			</LinkContainer>
			:
			<label>Become a premium user to use this feature.</label>
		;

		return (
			<Row className="row-setting">
				<Col xs={labelSize}>
					{label}
				</Col>
				<Col xs={12-labelSize}>
					{(isPremiumFeature && !isPremiumUser) ?
						premiumComponent
						:
						React.cloneElement(this.props.children, { enabled })
					}
				</Col>
			</Row>
		);
	}
}

Setting.defaultProps = {
	enabled: true
};

Setting.propTypes = {
	children: PropTypes.element,
	label: PropTypes.string,
	labelSize: PropTypes.number,
	isPremiumFeature: PropTypes.bool,
	isPremiumUser: PropTypes.bool,
	enabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./Components/components/Setting.jsx